/**
 * 时间格式化工具函数
 * 格式化为 yyyy-MM-dd hh:mm，时区为东八区（北京时区）
 */

/**
 * 格式化日期时间为东八区格式
 * @param {string|Date|null} dateStr - ISO 日期字符串或 Date 对象
 * @param {string} format - 输出格式，默认 yyyy-MM-dd hh:mm
 * @returns {string} 格式化后的时间字符串
 */
export function formatDateTime(dateStr, format = 'yyyy-MM-dd hh:mm') {
  if (!dateStr) return '-'

  // 创建 Date 对象
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return '-'

  // 后端返回的是 UTC 时间（0时区），需要转换为东八区
  // 直接获取 UTC 时间戳，然后加上 8 小时的偏移量
  const utcTime = date.getTime()
  const beijingTime = new Date(utcTime)

  const year = beijingTime.getFullYear()
  const month = String(beijingTime.getMonth() + 1).padStart(2, '0')
  const day = String(beijingTime.getDate()).padStart(2, '0')
  const hours = String(beijingTime.getHours()).padStart(2, '0')
  const minutes = String(beijingTime.getMinutes()).padStart(2, '0')

  return format
    .replace('yyyy', year)
    .replace('MM', month)
    .replace('dd', day)
    .replace('hh', hours)
    .replace('mm', minutes)
}

/**
 * 格式化日期（不含时间）
 * @param {string|Date|null} dateStr - ISO 日期字符串或 Date 对象
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(dateStr) {
  return formatDateTime(dateStr, 'yyyy-MM-dd')
}

/**
 * 格式化时间（含时分）
 * @param {string|Date|null} dateStr - ISO 日期字符串或 Date 对象
 * @returns {string} 格式化后的时间字符串
 */
export function formatTime(dateStr) {
  return formatDateTime(dateStr, 'hh:mm')
}

/**
 * 规范化日期时间展示文本：将 ISO 格式（yyyy-MM-ddTHH:mm:ss）中的 T/Z
 * 转为空格分隔（yyyy-MM-dd HH:mm:ss），保留秒；纯日期字符串原样返回
 * 用于后端时间字符串需要原样精度展示的场景
 * @param {string|Date|null|undefined} value - 后端返回的时间字符串
 * @returns {string} 规范化后的展示文本，空值返回 '-'
 */
export function formatDateTimeText(value) {
  if (value === null || value === undefined || value === '') return '-'
  return String(value).replace('T', ' ').replace('Z', '')
}

export default {
  formatDateTime,
  formatDate,
  formatTime,
  formatDateTimeText
}
